import { Form } from '@mairistem/composants';
import { MULTI, Sens } from '@mairistem/comptabilite';
import { Combobox, Icon, Panel } from '@mairistem/finances-utils';
import type { DropdownOption } from '@mairistem/liste';
import React from 'react';
import NATURE_PIECE_ORIGINE from '../../../../constants/mouvements/naturePieceOrigine';
import type PanelComponentProps from '../../../../interfaces/pieces/mouvements/panelComponentProps';
import './InformationsRattachementComponent.css';

const getNaturesOptions = (sens: Sens | string): DropdownOption[] => {
	if (sens === Sens.DEPENSE) {
		return [
			{
				'data-testid': `naturePieceOrigine${NATURE_PIECE_ORIGINE.MANDAT.MANDAT.CODE}`,
				key: NATURE_PIECE_ORIGINE.MANDAT.MANDAT.CODE,
				text: NATURE_PIECE_ORIGINE.MANDAT.MANDAT.LABEL,
				value: NATURE_PIECE_ORIGINE.MANDAT.MANDAT.CODE,
			},
			{
				'data-testid': `naturePieceOrigine${NATURE_PIECE_ORIGINE.MANDAT.TITRE.CODE}`,
				key: NATURE_PIECE_ORIGINE.MANDAT.TITRE.CODE,
				text: NATURE_PIECE_ORIGINE.MANDAT.TITRE.LABEL,
				value: NATURE_PIECE_ORIGINE.MANDAT.TITRE.CODE,
			},
			{
				'data-testid': `naturePieceOrigine${NATURE_PIECE_ORIGINE.MANDAT.PAIEMENT.CODE}`,
				key: NATURE_PIECE_ORIGINE.MANDAT.PAIEMENT.CODE,
				text: NATURE_PIECE_ORIGINE.MANDAT.PAIEMENT.LABEL,
				value: NATURE_PIECE_ORIGINE.MANDAT.PAIEMENT.CODE,
			},
			{
				'data-testid': `naturePieceOrigine${NATURE_PIECE_ORIGINE.MANDAT.LISTE_NON_VALEUR.CODE}`,
				key: NATURE_PIECE_ORIGINE.MANDAT.LISTE_NON_VALEUR.CODE,
				text: NATURE_PIECE_ORIGINE.MANDAT.LISTE_NON_VALEUR.LABEL,
				value: NATURE_PIECE_ORIGINE.MANDAT.LISTE_NON_VALEUR.CODE,
			},
			{
				'data-testid': `naturePieceOrigine${NATURE_PIECE_ORIGINE.MANDAT.ORDRE_PAIEMENT_ORDONNATEUR.CODE}`,
				key: NATURE_PIECE_ORIGINE.MANDAT.ORDRE_PAIEMENT_ORDONNATEUR.CODE,
				text: NATURE_PIECE_ORIGINE.MANDAT.ORDRE_PAIEMENT_ORDONNATEUR.LABEL,
				value: NATURE_PIECE_ORIGINE.MANDAT.ORDRE_PAIEMENT_ORDONNATEUR.CODE,
			},
		];
	}

	return [
		{
			'data-testid': `naturePieceOrigine${NATURE_PIECE_ORIGINE.TITRE.TITRE.CODE}`,
			key: NATURE_PIECE_ORIGINE.TITRE.TITRE.CODE,
			text: NATURE_PIECE_ORIGINE.TITRE.TITRE.LABEL,
			value: NATURE_PIECE_ORIGINE.TITRE.TITRE.CODE,
		},
		{
			'data-testid': `naturePieceOrigine${NATURE_PIECE_ORIGINE.TITRE.MANDAT.CODE}`,
			key: NATURE_PIECE_ORIGINE.TITRE.MANDAT.CODE,
			text: NATURE_PIECE_ORIGINE.TITRE.MANDAT.LABEL,
			value: NATURE_PIECE_ORIGINE.TITRE.MANDAT.CODE,
		},
		{
			'data-testid': `naturePieceOrigine${NATURE_PIECE_ORIGINE.TITRE.ENCAISSEMENT.CODE}`,
			key: NATURE_PIECE_ORIGINE.TITRE.ENCAISSEMENT.CODE,
			text: NATURE_PIECE_ORIGINE.TITRE.ENCAISSEMENT.LABEL,
			value: NATURE_PIECE_ORIGINE.TITRE.ENCAISSEMENT.CODE,
		},
		{
			'data-testid': `naturePieceOrigine${NATURE_PIECE_ORIGINE.TITRE.LISTE_MAJORATION.CODE}`,
			key: NATURE_PIECE_ORIGINE.TITRE.LISTE_MAJORATION.CODE,
			text: NATURE_PIECE_ORIGINE.TITRE.LISTE_MAJORATION.LABEL,
			value: NATURE_PIECE_ORIGINE.TITRE.LISTE_MAJORATION.CODE,
		},
	];
};

const SaisieLibreComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (_e, { name, value }) =>
		onChange?.({ [name]: value }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Group>
					<Form.Field
						control={Combobox}
						data-testid="saisieLibreNaturePieceOrigine"
						label="Nature de la pièce d'origine"
						name="naturePieceOrigine"
						onChange={handleChange}
						options={getNaturesOptions(data?.sens)}
						placeholder={data?.naturePieceOrigine === MULTI ? MULTI : ''}
						selection
						value={data?.naturePieceOrigine ?? ''}
						width={8}
					/>
					<Form.Input
						data-testid="saisieLibreExerRattachement"
						input={{ maxLength: 4 }}
						label="Exercice de rattachement"
						name="exerRattachement"
						onChange={handleChange}
						title={data?.exerRattachement ?? ''}
						value={data?.exerRattachement ?? ''}
						width={8}
					/>
				</Form.Group>
				<Form.Group className="panelRow">
					<Form.Input
						data-testid="saisieLibrePieceOrigine"
						label="Identifiant de la pièce d'origine"
						name="pieceOrigine"
						onChange={handleChange}
						title={data?.pieceOrigine ?? ''}
						value={data?.pieceOrigine ?? ''}
						width={7}
					/>
					<Form.Input
						data-testid="saisieLibreIdLigneOriginePes"
						label="Identifiant de la ligne de pièce d'origine"
						name="idLigneOriginePes"
						onChange={handleChange}
						title={data?.idLigneOriginePes ?? ''}
						value={data?.idLigneOriginePes ?? ''}
						width={7}
					/>
					<Form.Input
						circular
						className="panelButton"
						control={Icon}
						name="caret down"
						size="large"
						width={2}
					/>
				</Form.Group>
			</Form>
		</Panel>
	);
};

export default SaisieLibreComponent;
